/**
 * Autore: Salvo de Luca
 * Azienda Dialogicom s.r.l.s.
 * File: src/components/auth/useAuthActions.ts
 * Release: v2.2.0 - Hook per azioni di autenticazione
 * Data: 27/06/2025
 */

import { useCallback } from 'react';

export const useAuthActions = () => {
  const signOut = useCallback(async () => {
    console.log('🔐 [useAuthActions] ===== signOut INIZIATO =====');

    // PRIMA leggi il token per l'API
    const refreshToken = localStorage.getItem('refreshToken');
    console.log('🔐 [useAuthActions] refreshToken presente:', !!refreshToken);

    // Rimuovi token localmente (garantisce logout locale anche se API fallisce)
    console.log('🔐 [useAuthActions] Rimozione token da localStorage...');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    console.log('🔐 [useAuthActions] Token rimossi!');

    // Tenta logout API (fire and forget - non aspettiamo la risposta)
    if (refreshToken) {
      fetch('/api/auth/logout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ refresh_token: refreshToken }),
      }).catch(err => console.warn('🔐 [useAuthActions] API logout fallita (ignorato):', err));
    }

    // REDIRECT GARANTITO con piccolo delay per assicurare che i log vengano stampati
    console.log('🔐 [useAuthActions] ===== REDIRECT A /login =====');
    setTimeout(() => {
      window.location.href = '/login';
    }, 50);
  }, []);

  const forceSignOut = useCallback(async () => {
    console.log('🔐 [useAuthActions] ===== forceSignOut INIZIATO =====');

    // PRIMA leggi il token per l'API
    const refreshToken = localStorage.getItem('refreshToken');
    console.log('🔐 [useAuthActions] forceSignOut - refreshToken presente:', !!refreshToken);

    // Pulisci TUTTO immediatamente
    console.log('🔐 [useAuthActions] forceSignOut - Pulizia completa storage');
    localStorage.clear();
    sessionStorage.clear();

    // Rimuovi anche i cookie
    document.cookie.split(";").forEach(function(c) {
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    // Tenta logout API (fire and forget - non aspettiamo la risposta)
    if (refreshToken) {
      fetch('/api/auth/force-logout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ refresh_token: refreshToken }),
      }).catch(err => console.warn('🔐 [useAuthActions] forceSignOut - API fallita (ignorato):', err));
    }

    // REDIRECT GARANTITO con piccolo delay
    console.log('🔐 [useAuthActions] ===== forceSignOut REDIRECT A /login =====');
    setTimeout(() => {
      window.location.href = '/login';
    }, 50);
  }, []);

  const refreshUser = useCallback(async () => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      try {
        console.log('🔐 [AUTH ACTIONS] Refresh user con token...');
        const response = await fetch('/api/auth/me', {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          const data = await response.json();
          console.log('🔐 [AUTH ACTIONS] User aggiornato:', data.user);
          // Ricarica la pagina per aggiornare il context
          window.location.reload();
        } else {
          console.log('🔐 [AUTH ACTIONS] Token scaduto durante refresh');
          // Token scaduto, fai logout
          await signOut();
        }
      } catch (error) {
        console.error('🔐 [AUTH ACTIONS] Errore refresh user:', error);
        await signOut();
      }
    }
  }, [signOut]);

  return {
    signOut,
    forceSignOut,
    refreshUser
  };
}; 